var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16.084C30 8.35273 23.7313 2.08398 16 2.08398C8.26875 2.08398 2 8.35273 2 16.084C2 23.0715 7.11875 28.8634 13.8125 29.9146V20.1321H10.2569V16.084H13.8125V12.9996C13.8125 9.49148 15.9031 7.55211 19.1006 7.55211C20.6325 7.55211 22.235 7.82586 22.235 7.82586V11.2715H20.4688C18.7306 11.2715 18.1869 12.3502 18.1869 13.459V16.084H22.0694L21.4494 20.1321H18.1875V29.9159C24.8813 28.8652 30 23.0734 30 16.084Z",
    fill: "#E84137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.cf605d68d4e7ffeeb27fc8128146b760.svg";
export { ForwardRef as ReactComponent };